<template>
  <div>
    <!-- 侧边栏 -->
    <Drawers :drawers="drawer" @drawerVisible="handleClose" @fatherMethods="getfun1">
      <template #desc>
        <el-tabs v-model="drawer.activeName">
          <el-tab-pane label="基本信息" name="1">
            <div class="info_conts" :style="'height:' + height + 'px'">
              <div class="info_titleimg">
                <!-- 无权限 -->
                <div style="text-align: center" v-if="drawer.info.cover!=''">
                  <div class="info_card_imgs">
                    <img class="info_card_img" v-if="!coverImgInfo.url" src="https://scpcm.oss-cn-hangzhou.aliyuncs.com/static/pc/coverImg/direct.png">
                    <img class="info_card_img" v-if="coverImgInfo.url" :src="coverImgInfo.url" @error="setDefaultImage">
                  </div>
                  <div v-if="drawer.info.editFlag&&drawer.info.delFlag!='2'" @click="coverImgDialog">
                    <el-button class="upload_btn" icon="iconfont icon-daochu upload_icon">上传封面</el-button>
                  </div>
                </div>
                <div v-if="drawer.info.editFlag&&drawer.info.delFlag!='2'&&drawer.info.cover==''">
                  <div class="upload_box" @click="coverImg">
                    <i class="iconfont icon-daochu upload_icon" />
                    <div>上传封面</div>
                  </div>
                </div>
              </div>
              <!-- 项目名称 -->
              <div class="info">
                <div class="info_key">
                  <div style="margin-left:11px" />
                  <i
                    class="iconfont icon-task info_icon"
                    style="font-size: 12px"
                  />
                  <el-tooltip
                    effect="dark"
                    content="项目名称"
                    placement="bottom"
                    popper-class="texttooltip"
                  >
                    <div>项目名称</div>
                  </el-tooltip>
                </div>
                <div class="info_value" style="width:calc(100% - 282px)!important" v-if="drawer.info.editFlag&&drawer.info.delFlag!='2'&&edit_input=='input_name'" @click.stop="permissionsChange('input_name')">
                  <el-input
                    @blur="editTaskChange"
                    ref="input_name"
                    :autofocus="true"
                    v-model="proname"
                    placeholder="点击添加"
                  />
                </div>
                <div :class="drawer.info.editFlag ? 'info_valueEditFlag': 'info_value'" style="width:calc(100% - 282px) !important" v-else @click.stop="permissionsChange('input_name')">
                  <div class="info_value_text">{{proname}}</div>
                </div>
              </div>
              <!-- 项目编号 -->
              <div class="info">
                <div class="info_key">
                  <div style="margin-left:11px" />
                  <i
                    class="iconfont icon-bianhao info_icon"
                    style="font-size: 19px"
                  />
                  <el-tooltip
                    effect="dark"
                    content="项目编号"
                    placement="bottom"
                    popper-class="texttooltip"
                  >
                    <div>项目编号</div>
                  </el-tooltip>
                </div>
                <div
                  class="info_value"
                  style="width:calc(100% - 282px)!important"
                  v-if="drawer.info.editFlag&&drawer.info.delFlag!='2'&&edit_input=='input_serial'"
                  @click.stop="permissionsChange('input_serial')"
                >
                  <el-input
                    @blur="editTaskChange"
                    ref="input_serial"
                    v-model="proNumber"
                    placeholder="点击添加"
                  />
                </div>
                <!-- 无权限 -->
                <div :class="drawer.info.editFlag ? 'info_valueEditFlag': 'info_value'" style="width:calc(100% - 282px) !important" v-else @click.stop="permissionsChange('input_serial')">
                  <div class="info_value_text">{{proNumber}}</div>
                </div>
              </div>
              <!-- 表单类型 -->
              <div class="info">
                <div class="info_key">
                  <div style="margin-left:11px" />
                  <i
                    class="iconfont icon-type info_icon"
                    style="font-size: 13px"
                  />
                  <el-tooltip
                    effect="dark"
                    content="表单类型"
                    placement="bottom"
                    popper-class="texttooltip"
                  >
                    <div>表单类型</div>
                  </el-tooltip>
                </div>
                <div
                  class="info_value"
                  v-if="drawer.info.editFlag&&drawer.info.delFlag!='2'&&edit_input=='input_form'"
                  @click.stop="permissionsChange('input_form', 'select')"
                  style="height: 35px"
                >
                  <el-select
                    ref="input_form"
                    v-model="drawer.info.formId"
                    filterable
                    placeholder="请选择表单类型"
                    @change="editTaskChange('form')"
                  >
                    <el-option
                      v-for="item in formList"
                      :key="item.id"
                      :label="item.formName"
                      :value="item.id"
                    />
                  </el-select>
                </div>
                <!-- 无权限 -->
                <div
                  :class="drawer.info.editFlag ? 'info_valueEditFlag': 'info_value'"
                  style="height: 35px;width:calc(100% - 282px) !important"
                  v-else
                  @click.stop="permissionsChange('input_form', 'select')"
                >
                  <div class="info_value_text" v-if="drawer.info.formId">
                    <span
                      v-show="drawer.info.form.id == drawer.info.formId"
                    >{{drawer.info.form.formName}}</span>
                  </div>
                  <div class="info_value_text" v-else>标准表单</div>
                </div>
              </div>
              <!-- 负责人 -->
              <div class="info">
                <div class="info_key">
                  <div style="margin-left:11px" />
                  <i class="iconfont icon-fuzeren info_icon" />
                  <el-tooltip
                    effect="dark"
                    content="负责人"
                    placement="bottom"
                    popper-class="texttooltip"
                  >
                    <div>负责人</div>
                  </el-tooltip>
                </div>
                <div :class="drawer.info.editFlag ? 'info_valueEditFlag': 'info_value'">
                  <div class="personnel" v-if="!drawer.info.editFlag||drawer.info.delFlag=='2'">
                    <div class="info_personnel info_value_text" v-for="(item,index) in drawer.principalUsers" :key="index">
                      <img v-if="item.avatar!=''&& item.avatar !== null" class="info_personnel_surname" :src="item.avatar">
                      <div v-else class="info_personnel_surname">{{(item.name).substring(0,1)}}</div>
                      <div v-if="channel === 'wechat'">
                        <ww-open-data type="userName" :openid="item.name" />
                      </div>
                      <div v-else>{{item.name}}</div>
                    </div>
                  </div>
                  <div v-else class="add_text">
                    <div class="info_box">
                      <!--  v-if="drawer.principalUsers&&drawer.principalUsers.length>0" -->
                      <div class="info_personnel" v-for="(item,index) in drawer.principalUsers" :key="index" @click="contactCh(drawer.principalUsers, 0)">
                        <img v-if="item.avatar!=''&& item.avatar !== null" class="info_personnel_surname" :src="item.avatar">
                        <div v-else class="info_personnel_surname">{{(item.name).substring(0,1)}}</div>
                        <div v-if="channel === 'wechat'"> <ww-open-data type="userName" :openid="item.name" /></div>
                        <div v-else>{{item.name}}</div>
                      </div>
                      <i class="iconfont icon-jiahao2fill add_icon" @click="contactCh(drawer.principalUsers, 0)" :style="drawer.principalUsers&&drawer.principalUsers.length>0?'margin: 0 24px;':'margin: 0'" />
                    </div>
                    <!-- <div v-else class="info_value_text" @click="contactCh(drawer.principalUsers, 0)">点击添加</div> -->
                  </div>
                </div>
              </div>
              <!-- 计划时间 -->
              <div class="info">
                <div class="info_key">
                  <div style="margin-left:11px" />
                  <i
                    class="iconfont icon-riqi info_icon"
                    style="font-size: 17px"
                  />
                  <el-tooltip
                    effect="dark"
                    content="计划时间"
                    placement="bottom"
                    popper-class="texttooltip"
                  >
                    <div @click.stop="permissionsDateStart('input_dateStart')">计划时间</div>
                  </el-tooltip>
                </div>
                <div :class="drawer.info.editFlag ? 'info_valueEditFlag': 'info_value'" style="width:calc(100% - 282px)">
                  <div style="width:47%" v-if="drawer.info.editFlag&&drawer.info.delFlag!='2'&&edit_input=='input_dateStart'" @click.stop="permissionsDateStart('input_dateStart')">
                    <el-date-picker
                      @blur="editTaskChange"
                      type="date"
                      ref="input_dateStart"
                      v-model="drawer.info.planStartDate"
                      placeholder="点击添加"
                      value-format="yyyy/MM/dd HH:mm:ss"
                      format="yyyy/MM/dd"
                      :clearable="false"
                      :picker-options="pickerOptions"
                      style="width:100%"
                    />
                  </div>
                  <!-- 无权限 -->
                  <div v-else class="info_value_text" style="width:calc(47% - 12px);height:35px;cursor: pointer" @click.stop="permissionsDateStart('input_dateStart')">{{drawer.info.planStartDate?(drawer.info.planStartDate).substring(0, 10):''}}</div>
                  <div style="color:#909090" v-if="drawer.info.planStartDate&&drawer.info.planStartDate">-</div>
                  <div style="width:47%" v-if="drawer.info.editFlag&&drawer.info.delFlag!='2'&&edit_input=='input_dateEnd'" @click.stop="permissionsDateEnd('input_dateEnd')">
                    <el-date-picker
                      @blur="editTaskChange"
                      type="date"
                      ref="input_dateEnd"
                      v-model="drawer.info.planEndDate"
                      placeholder="点击添加"
                      value-format="yyyy/MM/dd HH:mm:ss"
                      format="yyyy/MM/dd"
                      :clearable="false"
                      :picker-options="pickerOptions1"
                      style="width:100%"
                    />
                  </div>
                  <!-- 无权限 -->
                  <div v-else class="info_value_text" style="width:calc(47% - 12px);height:35px;cursor: pointer" @click.stop="permissionsDateEnd('input_dateEnd')">{{drawer.info.planEndDate?(drawer.info.planEndDate).substring(0, 10):''}}</div>
                </div>
              </div>
              <!-- 订金日期 v-if="drawer.info.proTypeId == '0'&& corpId === 'ding379884b8b194a55f35c2f4657eb6378f'-->
              <div class="info" v-if="drawer.info.proTypeId == '0'&&corpId === 'ding379884b8b194a55f35c2f4657eb6378f'">
                <div class="info_key">
                  <div style="width:11px" />
                  <i class="iconfont icon-riqi info_icon" style="font-size: 17px" />
                  <el-tooltip
                    effect="dark"
                    content="订金"
                    placement="bottom"
                    popper-class="texttooltip"
                  >
                    <div>订金</div>
                  </el-tooltip>
                </div>
                <div class="info_value">
                  <div
                    style="width: 177px"
                    v-if="
                      drawer.info.editFlag&&drawer.info.delFlag!='2'&&
                        edit_input == 'input_dateStartDep'
                    "
                    @click.stop="permissionsDateStartDep('input_dateStartDep')"
                  >
                    <el-date-picker
                      @blur="editTaskChange('depositDate', drawer.info.depositDate)"
                      type="datetime"
                      ref="input_dateStartDep"
                      v-model="drawer.info.depositDate"
                      :picker-options="pickerOptions"
                      placeholder="点击添加"
                      value-format="yyyy/MM/dd HH:mm:ss"
                      format="yyyy/MM/dd"
                      :clearable="false"
                      style="width: 100%"
                      default-time="00:00:00"
                    />
                  </div>
                  <!-- 有权限 -->
                  <div
                    v-else
                    :class="drawer.info.status != '2' ? 'info_valueEditFlag1': 'info_value_text'"
                    style="width: 100% !important; height: 35px;cursor: pointer;margin-left: 11px;"
                    @click.stop="permissionsDateStartDep('input_dateStartDep')"
                  >
                    <span v-if="drawer.info.depositDate">{{drawer.info.depositDate.substring(0, 10)}}</span>
                  </div>
                </div>
              </div>
              <!-- 图纸确认日期 -->
              <div class="info" v-if="drawer.info.proTypeId == '0'&&corpId === 'ding379884b8b194a55f35c2f4657eb6378f'">
                <div class="info_key">
                  <div style="width:11px" />
                  <i class="iconfont icon-riqi info_icon" style="font-size: 17px" />
                  <el-tooltip
                    effect="dark"
                    content="图纸确认"
                    placement="bottom"
                    popper-class="texttooltip"
                  >
                    <div class="form_fieldName">图纸确认</div>
                  </el-tooltip>
                </div>
                <div class="info_value">
                  <div
                    style="width: 177px"
                    v-if="
                      drawer.info.editFlag&&drawer.info.delFlag!='2'&&
                        edit_input == 'input_dateStartDraw'
                    "
                    @click.stop="permissionsDateStartDraw('input_dateStartDraw')"
                  >
                    <el-date-picker
                      @blur="editTaskChange('drawingDate', drawer.info.drawingDate)"
                      type="datetime"
                      ref="input_dateStartDraw"
                      v-model="drawer.info.drawingDate"
                      :picker-options="pickerOptions"
                      placeholder="点击添加"
                      value-format="yyyy/MM/dd HH:mm:ss"
                      format="yyyy/MM/dd"
                      :clearable="false"
                      style="width: 100%"
                      default-time="00:00:00"
                    />
                  </div>
                  <!-- 有权限 -->
                  <div
                    v-else
                    :class="drawer.info.status != '2' ? 'info_valueEditFlag1': 'info_value_text'"
                    style="width: 100% !important; height: 35px;cursor: pointer;margin-left: 11px;"
                    @click.stop="permissionsDateStartDraw('input_dateStartDraw')"
                  >
                    <span v-if="drawer.info.drawingDate">{{drawer.info.drawingDate.substring(0, 10)}}</span>
                  </div>
                </div>
              </div>
              <!-- 预计完成日期 -->
              <div class="info" v-if="drawer.info.proTypeId == '0'&&corpId === 'ding379884b8b194a55f35c2f4657eb6378f'">
                <div class="info_key">
                  <div style="width:11px" />
                  <i class="iconfont icon-riqi info_icon" style="font-size: 17px" />
                  <el-tooltip
                    effect="dark"
                    content="预计完成"
                    placement="bottom"
                    popper-class="texttooltip"
                  >
                    <div class="form_fieldName">预计完成</div>
                  </el-tooltip>
                </div>
                <div class="info_value">
                  <div
                    style="width: 177px"
                    v-if="
                      edit_input == 'input_dateStartPlanEnd'
                    "
                    @click.stop="permissionsDateStartPlanEnd('input_dateStartPlanEnd')"
                  >
                    <el-date-picker
                      @blur="editTaskChange('prodPlanEndDate', drawer.info.prodPlanEndDate)"
                      type="datetime"
                      ref="input_dateStartPlanEnd"
                      v-model="drawer.info.prodPlanEndDate"
                      :picker-options="pickerOptions"
                      placeholder="点击添加"
                      value-format="yyyy/MM/dd HH:mm:ss"
                      format="yyyy/MM/dd"
                      :clearable="false"
                      style="width: 100%"
                      default-time="00:00:00"
                    />
                  </div>
                  <!-- 有权限 -->
                  <div
                    v-else
                    :class="drawer.info.status != '2' ? 'info_valueEditFlag1': 'info_value_text'"
                    style="width: 100% !important; height: 35px;cursor: pointer;margin-left: 11px;"
                    @click.stop="permissionsDateStartPlanEnd('input_dateStartPlanEnd')"
                  >
                    <span v-if="drawer.info.prodPlanEndDate">{{drawer.info.prodPlanEndDate.substring(0, 10)}}</span>
                  </div>
                </div>
              </div>
              <!-- 表单 -->
              <Form
                v-if="drawer.info.formId&&drawer.info.formId != '0'"
                :form-json="formJson"
                :drawer="drawer"
                ref="forms"
                @editTaskChange="editTaskChange"
                @checkboxGroup="checkboxGroup"
                @closeEditForm="edit_input = ''"
              />
              <!-- 描述 -->
              <div class="info" v-if="!drawer.info.formId || drawer.info.formId == '0'">
                <div class="info_key">
                  <div style="margin-left:11px" />
                  <i
                    class="iconfont icon-describe info_icon"
                    style="font-size: 14px"
                  />
                  <el-tooltip
                    effect="dark"
                    content="描述"
                    placement="bottom"
                    popper-class="texttooltip"
                  >
                    <div @click.stop="permissionsChange('describe')">描述</div>
                  </el-tooltip>
                </div>
                <div
                  style="width:calc(100% - 102px)"
                  @click.stop="permissionsChange('describe')"
                  v-if="drawer.info.editFlag&&drawer.info.delFlag!='2'&&edit_input=='describe'"
                >
                  <Describe :describes="drawer.describes" @func="getMsgFormSon" />
                </div>
                <!-- 无权限 -->
                <div :class="drawer.info.editFlag ? 'info_valueEditFlag': 'info_value'" v-else @click.stop="permissionsChange('describe')" style="min-height: 35px;">
                  <div class="info_value_text" style="margin-top:2px">
                    <div style="min-height:35px;cursor: pointer" v-if="drawer.describes.describe" v-html="$httpFormart(drawer.describes.describe)">{{drawer.describes.describe}}</div>
                    <div class="file_list">
                      <div v-for="(item,index) in drawer.describes.descList" :key="index" @click.stop="fileLists(item)">
                        <i class="iconfont icon-wenjian file__icon" />
                        <span>{{item.fileName}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 标签 -->
              <div class="info" v-if="!drawer.info.formId || drawer.info.formId == '0'" style="margin-bottom: 20px">
                <div class="info_key">
                  <div style="margin-left:11px" />
                  <i class="iconfont icon-tag info_icon" />
                  <el-tooltip
                    effect="dark"
                    content="标签"
                    placement="bottom"
                    popper-class="texttooltip"
                  >
                    <div>标签</div>
                  </el-tooltip>
                </div>
                <div class="info_value" v-if="!drawer.info.editFlag||drawer.info.delFlag=='2'">
                  <div class="info_box" style="margin-left:11px" v-show="drawer.info.labelList&&drawer.info.labelList.length>0">
                    <el-tag
                      v-for="(tag,index1) in drawer.info.labelList"
                      :key="index1"
                      style="margin-right: 16px"
                      type="warning"
                    >{{tag.labelName}}</el-tag>
                  </div>
                </div>
                <div v-else class="info_value">
                  <div class="info_box" style="margin-left:11px">
                    <div class="info_tags" v-for="(tag,index1) in drawer.info.labelList" :key="index1" v-show="drawer.info.labelList&&drawer.info.labelList.length>0">
                      <el-tag
                        style="margin-right: 16px;"
                        :style="'color:'+tag.color+';background:'+convertHex(tag.color, 10)"
                        type="warning"
                      >{{tag.labelName}}</el-tag>
                      <i class="iconfont icon-shanchu del_icon" @click="delTagsChange(tag)" />
                    </div>
                    <el-popover
                      placement="bottom"
                      width="540"
                      trigger="click"
                    >
                      <TagsList :tags-objects="tagsObject" :tag-lists="tagList" />
                      <i class="iconfont icon-jiahao2fill add_icon" @click="tagListchange" :style="drawer.info.labelList&&drawer.info.labelList.length>0?'margin: 0 24px;':'margin: 0'" slot="reference" />
                    </el-popover>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="成员" name="2">
            <div class="info_conts" :style="'height:' + height + 'px'">
              <div class="info">
                <div class="info_key" style="width: 108px;">
                  <i
                    class="iconfont icon-task info_icon"
                    style="font-size: 12px"
                  />
                  <div>管理员（{{drawer.manageUsers.length>0?drawer.manageUsers.length:0}}）</div>
                </div>
                <el-tooltip effect="dark" popper-class="texttooltip" content="管理员可以管理项目内任务" placement="right">
                  <i
                    class="iconfont icon-shuoming info_icon info_icon_show"
                    style="font-size: 14px"
                  />
                </el-tooltip>
              </div>
              <!-- 有权限 -->
              <div class="users_personnel" v-if="drawer.info.editFlag&&drawer.info.delFlag!='2'">
                <div class="user_personnel" v-for="(item,index) in drawer.manageUsers" :key="index">
                  <div class="info_personnel" @click="contactCh(drawer.manageUsers, 1)">
                    <img v-if="item.avatar!=''&& item.avatar !== null" class="info_personnel_surname" :src="item.avatar">
                    <div v-else class="info_personnel_surname">{{(item.name).substring(0,1)}}</div>
                    <div v-if="channel === 'wechat'"> <ww-open-data type="userName" :openid="item.name" /></div>
                    <div v-else>{{item.name}}</div>
                  </div>
                  <i class="iconfont icon-shanchu del_icon" @click="delUsers(drawer.manageUsers, index, 1)" />
                </div>
                <i class="iconfont icon-jiahao2fill add_icon" @click="contactCh(drawer.manageUsers, 1)" :style="drawer.manageUsers.length>0?'margin-left:34px':''" />
              </div>
              <!-- 无权限 -->
              <div class="users_personnel" v-else>
                <div class="info_personnel" v-for="(item,index) in drawer.manageUsers" :key="index">
                  <img v-if="item.avatar!=''&& item.avatar !== null" class="info_personnel_surname" :src="item.avatar">
                  <div v-else class="info_personnel_surname">{{(item.name).substring(0,1)}}</div>
                  <div v-if="channel === 'wechat'"> <ww-open-data type="userName" :openid="item.name" /></div>
                  <div v-else>{{item.name}}</div>
                </div>
              </div>
              <div class="info">
                <div class="info_key" style="width: 122px;">
                  <i
                    class="iconfont icon-task info_icon"
                    style="font-size: 12px"
                  />
                  <div>项目成员（{{drawer.memberUsers.length>0?drawer.memberUsers.length:0}}）</div>
                </div>
                <el-tooltip effect="dark" popper-class="texttooltip" content="项目成员可以查看项目内任务" placement="right">
                  <i
                    class="iconfont icon-shuoming info_icon info_icon_show"
                    style="font-size: 14px"
                  />
                </el-tooltip>
              </div>
              <!-- 有权限 -->
              <div class="users_personnel" v-if="drawer.info.editFlag&&drawer.info.delFlag!='2'">
                <div class="user_personnel" v-for="(item,index) in drawer.memberUsers" :key="index">
                  <div class="info_personnel" @click="contactCh(drawer.memberUsers, 2)">
                    <img v-if="item.avatar!=''&& item.avatar !== null" class="info_personnel_surname" :src="item.avatar">
                    <div v-else class="info_personnel_surname">{{(item.name).substring(0,1)}}</div>
                    <div v-if="channel === 'wechat'">
                      <ww-open-data type="userName" :openid="item.name" />
                    </div>
                    <div v-else>{{item.name}}</div>
                  </div>
                  <i class="iconfont icon-shanchu del_icon" @click="delUsers(drawer.memberUsers, index, 2)" />
                </div>
                <i class="iconfont icon-jiahao2fill add_icon" @click="contactCh(drawer.memberUsers, 2)" :style="drawer.memberUsers.length>0?'margin-left:34px':''" />
              </div>
              <!-- 无权限 -->
              <div class="users_personnel" v-else>
                <div class="info_personnel" v-for="(item,index) in drawer.memberUsers" :key="index">
                  <img v-if="item.avatar!=''&& item.avatar !== null" class="info_personnel_surname" :src="item.avatar">
                  <div v-else class="info_personnel_surname">{{(item.name).substring(0,1)}}</div>
                  <div v-if="channel === 'wechat'">
                    <ww-open-data type="userName" :openid="item.name" /></div>
                  <div v-else>{{item.name}}</div>
                </div>
              </div>
              <div class="info">
                <div class="info_key" style="width: 122px;">
                  <i
                    class="iconfont icon-chengyuan-tianjia info_icon"
                    style="font-size: 15px"
                  />
                  <div>成员范围</div>
                </div>
              </div>
              <!-- 有权限 -->
              <div class="users_personnel" v-if="drawer.info.editFlag&&drawer.info.delFlag!='2'">
                <div class="info_personnel">
                  <el-radio-group v-model="drawer.info.autoAddMember" @change="statusChange">
                    <el-radio label="0">任务成员默认加入</el-radio>
                    <el-radio label="1">手动添加项目成员</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <!-- 无权限 -->
              <div class="users_personnel" v-else>
                <div class="info_personnel">
                  <el-radio-group v-model="drawer.info.autoAddMember" disabled>
                    <el-radio label="0">任务成员默认加入</el-radio>
                    <el-radio label="1">手动添加项目成员</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </template>
    </Drawers>
    <!-- 侧边栏弹框 -->
    <dialogs
      ref="drawersDialog"
      :drawer="drawer"
      @fatherMethods="openDrawer"
      @func="cover"
      :proid="proid"
      @archiveMethod="archiveChange"
      @proDelChange="proDelChange"
    />
    <!-- 视频预览组件 -->
    <VideoPreview
      :visible.sync="showVideo"
      :url="videoUrl"
      @update:visible="val => console.log('visible 更新为:', val)"
    />
  </div>
</template>

<script>
import dialogs from './dialogs.vue'
import Describe from '../../components/common/describe.vue'
import Drawers from '../../components/common/drawers/index.vue'
import TagsList from '../../components/common/tagsList.vue'
import noDate from '../../components/common/noDate.vue'
import timeout from '../../components/common/timeout.vue'
import Form from '../../components/common/editProForm.vue'
import VideoPreview from '../../components/common/videoPreview/index.vue'
import { proDetail, findProUser, savePro, updateProLabel, findLabelList, saveProUser } from '../../utils/api/project'
import { findAllFrom } from '../../utils/api/task.js'
import { findUserIds } from '../../utils/api/user.js'
import { initPreviewAuth } from '../../utils/api/file'
import preview from 'dingtalk-jsapi/api/biz/cspace/preview' // 预览文件
import { wpsOfficeConfig } from '../../utils/wpsoffice/wpsOffice'
import { editChange, delChange } from '../../utils/tag.js'
import choose from 'dingtalk-jsapi/api/biz/contact/choose' // PC 通讯录选人
import { feishuContactChoose } from '../../utils/fsConfig'
import Vue from 'vue'
import { wxConfig } from '../../utils/wxConfig'
export default {
  name: 'Task',
  // eslint-disable-next-line vue/no-unused-components
  components: { Drawers, noDate, timeout, dialogs, Describe, TagsList, Form, VideoPreview },
  data() {
    return {
      UserData: JSON.parse(sessionStorage.getItem('loginUserData')),
      corpId: JSON.parse(sessionStorage.getItem('loginUserData')).corpId,
      channel: JSON.parse(sessionStorage.getItem('loginUserData')).channel,
      tryOutType: JSON.parse(sessionStorage.getItem('loginUserData')).tryOutType,
      autoAddMember: [],
      coverImgInfo: {},
      coverImgInfo_: {},
      checked: false,
      height: 0,
      clientHeights: document.documentElement.clientHeight,
      // 侧边栏
      drawer: {
        activeName: '1',
        fun: this.closePermission,
        direction: false, // 显示
        size: '42%',
        collection: true, // 收藏
        kpi: true, // kpi
        more: true, // 更多
        moreList: [
          {
            id: '1',
            value: '复制项目'
          },
          {
            id: '2',
            value: '归档项目'
          },
          {
            id: '3',
            value: '删除项目'
          }
        ],
        morefun: this.handleCommand,
        type: '3',
        state: 'subjects',
        infoList: [],
        describes: {
          appendType: '1',
          objectType: '3', // 项目描述
          objectId: '',
          type: '9',
          describe: '',
          proId: '',
          maxlength_show: true,
          descList: [],
          editTaskChange: this.editTaskChange
        },
        info: {
          createUser: {
            name: ''
          },
          createDate: ''
        },
        principalUsers: [],
        manageUsers: [],
        memberUsers: [],
        slotName: 'desc'
      },
      proname: '', // 项目编号
      proNumber: '', // 项目编号
      // 标签列表
      tagList: [],
      tagsObject: {
        checkboxGroup: [],
        fun: this.checkboxGroupChange
      },
      // 项目id
      proid: '',
      // 时间选择范围
      pickerOptions: {},
      // 时间选择范围
      pickerOptions1: {},
      formJson: [],
      formList: [],
      edit_input: '', // 基本信息编辑
      PermissionVersion: {},
      showVideo: false,
      videoUrl: ''
    }
  },
  watch: {
    check_list: {
      handler(value) {
      }
    }
  },
  mounted() {
    this.height = this.clientHeights - 300
    const that = this
    window.onresize = () =>
      (() => {
        that.height = document.documentElement.clientHeight - 300
      })()
    this.UserData.versionArray.map((item) => {
      this.PermissionVersion = item
    })
    if (this.channel === 'wechat') {
      wxConfig()
    }
  },
  methods: {
    getfun1(data) {
      this.openDrawer(data)
    },
    // 成员授权
    statusChange(val) {
      // if (this.autoAddMember.length > 1) {
      //   this.autoAddMember.splice(0, 1)
      // }

      this.drawer.info.autoAddMember = val
      this.editTaskChange()
    },
    // 项目内归档
    archiveChange() {
      this.$emit('archiveMethod')
    },
    // 项目删除
    proDelChange() {
      this.$emit('fatherDel')
    },
    // 失败图片
    setDefaultImage(e) {
      e.target.src = 'https://scpcm.oss-cn-hangzhou.aliyuncs.com/static/pc/coverImg/direct.png'
    },
    // 文件预览
    fileLists(item) {
      var date = {
        fileIds: item.dingFileId
      }
      if (item?.source === 'ding') {
        initPreviewAuth(date).then((data) => {
          if (data.code === 10000) {
            preview({
              corpId: JSON.parse(sessionStorage.getItem('loginUserData')).corpId,
              spaceId: item.dingSpaceId,
              fileId: item.dingFileId,
              fileName: item.fileName,
              fileSize: item.fileSize,
              fileType: item.fileFormat,
              onSuccess: function(res) {
                console.log(res, '')
              },
              onFail: function(err) {
                console.log(err)
              // alert('数据 ' + JSON.stringify(err))
              }
            })
          }
        }).catch((error) => {
          console.log(error)
        //  this.$message.error('网络错误，请稍候！')
        })
      } else {
        var imgs = ['MP4', 'AVI', 'WMV', 'MKV', 'FLV', 'MPG', 'MPEG', 'M2V', 'M3U8', 'TS', 'MOV', 'WMV', 'RM', 'RMVB', 'ASF', 'VOB', 'DAT', 'DV', 'M4V', 'WEBM', 'OGG', '3GP', 'MPEG4',
          'mp4', 'avi', 'wmv', 'mkv', 'flv', 'mpg', 'mpeg', 'm2v', 'm3u8', 'ts', 'mov', 'wmv', 'rm', 'rmvb', 'asf', 'vob', 'dat', 'dv', 'm4v', 'webm', 'ogg', '3gp', 'mpeg'
        ]
        if (imgs.includes(item.fileFormat)) {
          this.showVideo = true
          this.videoUrl = item.absoUrl
        } else {
          wpsOfficeConfig(item)
        }
      }
    },
    // 钉钉通讯录选人组件
    contactChoose(userids, type, proId) {
      var that = this
      var multiple = true
      if (type === 0) {
        multiple = false
      } else {
        multiple = true
      }
      choose({
        multiple: multiple, // 是否多选：true多选 false单选； 默认true
        users: userids, // 默认选中的用户列表，员工userid；成功回调中应包含该信息
        corpId: JSON.parse(sessionStorage.getItem('loginUserData')).corpId, // 企业id
        max: 100, // 人数限制，当multiple为true才生效，可选范围1-1500
        onSuccess: function(res) {
          if (res.length > 0) {
            var date = {
              users: res
            }
            // alert('数据 ' + JSON.stringify(date))
            findUserIds(date).then((res1) => {
              if (res1.code === 10000 && res1.result.isAll) {
                that.saveProUsers(res1.result.userList, type, proId)
              } else if (res1.code === 10000 && !res1.result.isAll) {
                this.$message.warning(res1.result.unAuthUserNameList.join(',') + ' 未授权')
              } else {
                this.$message.warning(res1.info)
              }
            }).catch((error) => {
              console.log(error)
              //  this.$message.error('网络错误，请稍候！')
            })
          }
        },
        onFail: function(err) {
          console.log(err)
        }
      }).then((res) => {
        console.log('then______err', res)
        // alert('$ANTDD error: ' + JSON.stringify(err))
      }).catch((err) => {
        console.log('catch______err', err)
        // alert('$ANTDD error: ' + JSON.stringify(err))
      })
    },
    // 企微通讯录选人组件
    wechatLogin(userids, type, proId) {
      var that = this
      var multiple = 'multi'
      if (type === 0) {
        multiple = 'single'
      }
      if (this.tryOutType === '1') {
        Vue.prototype.$wx.invoke('selectPrivilegedContact', {
          'fromDepartmentId': -1, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
          'mode': multiple, // 必填，选择模式，single表示单选，multi表示多选
          'type': ['user'], // 必填，选择限制类型，指定department、user中的一个或者多个
          'selectedDepartmentIds': [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          'selectedUserIds': userids // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
        }, function(res) {
          if (res.err_msg === 'selectPrivilegedContact:ok') {
            if (typeof res.result === 'string') {
              res.result = JSON.parse(res.result) // 由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
            }
            const selectedUserList = res.result.userList || [] // 已选的成员列表
            const selectedTicket = res.result.selectedTicket || '' // 已选的成员Ticket列表
            if (selectedUserList.length > 0 || selectedTicket.length > 0) {
              var date = {
                type: 'user',
                users: selectedUserList,
                ticket: selectedTicket
              }
              // alert('数据 ' + JSON.stringify(date))
              findUserIds(date).then((res1) => {
                if (res1.code === 10000 && res1.result.isAll) {
                  that.saveProUsers(res1.result.userList, type, proId)
                } else {
                  this.$message.warning(res1.result.unAuthUserNameList.join(',') + ' 未授权')
                }
              }).catch((error) => {
                console.log(error)
              //  this.$message.error('网络错误，请稍候！')
              })
            }
          }
        })
      } else {
        Vue.prototype.$wx.invoke('selectEnterpriseContact', {
          'fromDepartmentId': -1, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
          'mode': multiple, // 必填，选择模式，single表示单选，multi表示多选
          'type': ['user'], // 必填，选择限制类型，指定department、user中的一个或者多个
          'selectedDepartmentIds': [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          'selectedUserIds': userids // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
        }, function(res) {
          if (res.err_msg === 'selectEnterpriseContact:ok') {
            if (typeof res.result === 'string') {
              res.result = JSON.parse(res.result) // 由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
            }
            const selectedUserList = res.result.userList // 已选的成员列表
            if (selectedUserList.length > 0) {
              var date = {
                users: selectedUserList
              }
              // alert('数据 ' + JSON.stringify(date))
              findUserIds(date).then((res1) => {
                if (res1.code === 10000 && res1.result.isAll) {
                  that.saveProUsers(res1.result.userList, type, proId)
                } else {
                  this.$message.warning(res1.result.unAuthUserNameList.join(',') + ' 未授权')
                }
              }).catch((error) => {
                console.log(error)
              //  this.$message.error('网络错误，请稍候！')
              })
            }
          }
        })
      }
    },
    // 飞书选人
    fsContactChoose(userids, type, proId) {
      var multiple = true
      if (type === 0) {
        multiple = false
      } else {
        multiple = true
      }
      feishuContactChoose(userids, multiple).then((res) => {
        if (res.length > 0) {
          const result = res.map(item => ({ id: item.openId }))
          var date = {
            users: result
          }
          findUserIds(date).then((res1) => {
            if (res1.code === 10000 && res1.result.isAll) {
              this.saveProUsers(res1.result.userList, type, proId)
            } else if (res1.code === 10000 && !res1.result.isAll) {
              this.$message.warning(res1.result.unAuthUserNameList.join(',') + ' 未授权')
            } else {
              this.$message.warning(res1.info)
            }
          }).catch((error) => {
            console.log(error)
          })
        }
      })
    },
    // 编辑项目负责人，管理员，成员
    saveProUsers(res, type, proId) {
      var that = this
      var userIds = []
      res.map((item) => {
        userIds.push(item.id)
      })
      // alert('项目成员1 ' + JSON.stringify(res1))
      var date1 = {
        proId,
        type,
        userIds
      }
      // alert('修改项目成员 ' + JSON.stringify(date1))
      saveProUser(date1).then(data => {
        if (data.code === 10000) {
          // alert('修改项目成员 ' + JSON.stringify(data))
          that.$message.success('修改项目成员成功！')
          that.getUserList(proId)
          this.drawers.info.principalUser = res[0]
        } else {
          this.$message.warning(data.info)
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 添加项目负责人，管理员，成员
    contactCh(principalUsers, type) {
      var userids = []
      principalUsers.map((item) => {
        userids.push(item.userid)
      })
      if (this.channel === 'ding') {
        this.contactChoose(userids, type, this.drawer.info.id)
      } else if (this.channel === 'wechat') {
        this.wechatLogin(userids, type, this.drawer.info.id)
      } else {
        this.fsContactChoose(userids, type, this.drawer.info.id)
      }
    },
    // 删除项目负责人，管理员，成员
    delUsers(principalUsers, index, type) {
      principalUsers.splice(index, 1)
      this.saveProUsers(principalUsers, type, this.drawer.info.id)
    },
    cover(coverImgInfo) {
      this.coverImgInfo = coverImgInfo
      this.editTaskChange()
    },
    // 上传封面
    coverImgDialog() {
      this.$refs.drawersDialog.coverImgInfo_ = this.coverImgInfo
      this.$refs.drawersDialog.dialog4.addDounced = true
    },
    // 选择项目封面
    coverImg(item) {
      this.$refs.drawersDialog.coverImgInfo_ = item
    },
    // 项目侧边栏基本信息描述
    getMsgFormSon(result) {
      this.drawer.describes.descList = result
      this.editTaskChange()
    },
    // 标签透明度
    convertHex(hex, opacity) {
      hex = hex?.replace('#', '')
      var r = parseInt(hex?.substring(0, 2), 16)
      var g = parseInt(hex?.substring(2, 4), 16)
      var b = parseInt(hex?.substring(4, 6), 16)
      var result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')'
      return result
    },
    // 编辑项目复制标签
    checkboxGroupChange1() {
      this.$refs.drawersDialog.dialog2.labelList = editChange(this.tagList, this.tagsObject1.checkboxGroup)
    },
    // 编辑项目标签
    checkboxGroupChange() {
      var date = {
        id: this.drawer.info.id,
        labelIds: this.tagsObject.checkboxGroup
      }
      updateProLabel(date).then((data) => {
        if (data.code === 10000) {
          // this.$message.success('项目标签设置成功！')
          this.drawer.info.labelList = editChange(this.tagList, this.tagsObject.checkboxGroup)
        } else {
          this.$message.warning(data.info)
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 项目表单标签
    checkboxGroup(arr, tagList) {
      this.tagsObject.checkboxGroup = arr || []
      this.tagList = tagList || []
      // this.getTabsList()
      this.checkboxGroupChange()
    },
    // 删除项目标签
    delTagsChange(tag) {
      this.tagsObject.checkboxGroup.splice(delChange(tag, this.tagsObject.checkboxGroup), 1)
      this.checkboxGroupChange()
    },
    // 赋值
    tagListchange() {
      this.getTabsList()
    },
    // 项目标签列表
    getTabsList() {
      this.tagsObject.checkboxGroup = []
      findLabelList().then((data) => {
        if (data.code === 10000) {
          this.tagList = data.result
          this.drawer.info.labelList.map((tag) => {
            this.tagsObject.checkboxGroup.push(tag.id)
          })
        } else {
          this.$message.warning(data.info)
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 打开侧边栏
    openDrawer(item, type) {
      var id = ''
      if (type === 'nodeUp') {
        id = item.projectId
        this.proid = item.projectId
      } else {
        id = item.id
        this.proid = item.id
      }
      this.getFromList()
      this.drawer.direction = true
      var that = this
      var date = {
        id: id
      }
      proDetail(date).then((data) => {
        if (data.code === 10000) {
          that.drawer.info = data.result
          that.proname = that.drawer.info.proname
          that.proNumber = that.drawer.info.proNumber
          that.drawer.delFlag = data.result.delFlag
          that.autoAddMember = data.result.autoAddMember.split(',')
          // that.getTabsList()
          that.drawer.describes.describe = data.result.proRemark
          that.drawer.describes.descList = data.result.fileList
          that.drawer.describes.objectId = item.id
          that.drawer.describes.proId = item.id

          this.formJson = []
          var formJson = data.result.formFields || []
          formJson.map((item, index) => {
            item.strArray = item.strArray || []
            this.formJson.push(item)
            if (item.formField.type === '2') {
              item.describes = {
                describe: item.content || '',
                maxlength_show: true,
                descList: item.files || [],
                editTaskChange: this.editFormChange,
                appendType: '1',
                objectType: '3',
                objectId: item.id,
                proId: item.id,
                type: '15',
                index
              }
            }
          })
          that.$refs.drawersDialog.coverImgInfo = {
            name: data.result.cover,
            url: data.result.cover
          }
          that.coverImgInfo = {
            name: data.result.cover,
            url: data.result.cover
          }
          that.$refs.drawersDialog.coverImgList.map((item_cover) => {
            if (item_cover.url === data.result.cover) {
              that.$refs.drawersDialog.coverImgInfo = item_cover
              that.coverImgInfo = item_cover
            }
          })
          if (type === 'nodeUp') {
            that.getUserList(item.projectId)
          } else {
            that.getUserList(item.id)
          }
          if (that.drawer.info.delFlag === '2') {
            that.drawer.moreList[1].value = '取消归档'
            that.$refs.drawersDialog.dialog3.title = '取消归档'
            that.$refs.drawersDialog.dialog3.operatorList = [
              { label: '取消', type: '', fun: that.$refs.drawersDialog.cancelDialog },
              { label: '确定', type: 'danger', fun: that.$refs.drawersDialog.submitFilingDialog }
            ]
            that.$refs.drawersDialog.dialog3.desc = '项目取消归档后可在“ 项目-所有归档 ”中查看，不可进行操作，不纳入统计。可随时项目归档，正常使用该项目。'
          } else {
            if (that.drawer.info.editFlag) {
              that.drawer.moreList = [
                {
                  id: '1',
                  value: '复制项目'
                },
                {
                  id: '2',
                  value: '归档项目'
                },
                {
                  id: '3',
                  value: '删除项目'
                }
              ]
            } else {
              that.drawer.moreList = [
                {
                  id: '1',
                  value: '复制项目'
                }
              ]
            }
          }
        } else {
          this.$message.warning(data.info)
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
      this.drawer.activeName = '1'
      this.edit_input = ''
    },
    // 项目侧边栏负责人，管理员，成员列表
    getUserList(id) {
      var date1 = {
        proId: id,
        types: ['0', '1', '2']
      }
      findProUser(date1).then((data) => {
        if (data.code === 10000) {
          this.drawer.principalUsers = data.result.principalUsers
          this.drawer.manageUsers = data.result.manageUsers
          this.drawer.memberUsers = data.result.memberUsers
          this.drawer.direction = true
        } else {
          this.$message.warning(data.info)
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 表单类型列表
    getFromList() {
      var date = {}
      findAllFrom(date)
        .then((data) => {
          if (data.code === 10000) {
            this.formList = data.result
          } else {
            this.$message.warning(data.info)
          }
        })
        .catch((error) => {
          console.log(error)
          //  this.$message.error('网络错误，请稍候！')
        })
    },
    // 编辑项目确定
    editTaskChange(type) {
      if (this.drawer.info.proname === '') {
        this.proname = this.drawer.info.proname
        this.$message.warning('项目名称不能为空，请重新填写！')
        return
      } else if (this.proNumber === '') {
        this.proNumber = this.drawer.info.proNumber
        this.$message.warning('项目编号不能为空，请重新填写！')
        return
      }
      var Ids = []
      this.drawer.describes.descList.map((item) => {
        Ids.push(item.id)
      })
      var date = {
        id: this.drawer.info.id,
        proNumber: this.proNumber,
        proname: this.proname,
        planStartDate: this.drawer.info.planStartDate,
        planEndDate: this.drawer.info.planEndDate,
        cover: this.coverImgInfo.url,
        proRemark: this.drawer.describes.describe,
        proRemarkFiles: Ids.join(','),
        formId: this.drawer.info.formId,
        autoAddMember: this.drawer.info.autoAddMember,
        depositDate: this.drawer.info.depositDate, // 订金日期
        drawingDate: this.drawer.info.drawingDate, // 图纸确认日期
        prodPlanEndDate: this.drawer.info.prodPlanEndDate // 预计完成日期
      }
      savePro(date).then((data) => {
        if (data.code === 10000) {
          this.drawer.info.proname = this.proname
          this.drawer.info.proNumber = this.proNumber
          this.drawer.info.proRemark = this.drawer.describes.describe
          this.drawer.info.fileList = this.drawer.describes.descList
          // this.$message.success('编辑项目成功！')
          this.closePermission()
          if (type === 'form') {
            this.openDrawer(data.result)
          }
        } else {
          this.$message.warning(data.info)
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 关闭前的回调(侧边栏)
    handleClose(val) {
      this.drawer.direction = false
      this.$emit('drawerVisible', this.drawer)
    },
    // 更多
    handleCommand(command) {
      // this.$message('click on item ' + command)
      if (command === '1') {
        if (!this.PermissionVersion.functionKey === 'copy_pro' && this.PermissionVersion.authority === true) {
          return this.$message.warning('当前版本暂不支持此功能，请升级版本')
        }
        this.$refs.drawersDialog.copyDialog(this.drawer.info)
      } else if (command === '2') {
        this.$refs.drawersDialog.dialog3.addDounced = true
        this.$refs.drawersDialog.dialog3.id = this.drawer.info.id
        this.$refs.drawersDialog.dialog3.proTypeId = this.drawer.info.proTypeId
      } else if (command === '3') {
        this.$refs.drawersDialog.dialog.addDounced = true
        this.$refs.drawersDialog.dialog.id = this.drawer.info.id
      }
    },
    // 开始时间
    permissionsDateStart(input) {
      var that = this
      this.pickerOptions = {
        disabledDate(time) {
          return time.getTime() > (Date.parse(that.drawer.info.planEndDate) - 86399000)
        }
      }
      this.permissionsChange(input)
    },
    // 结束时间
    permissionsDateEnd(input) {
      var that = this
      this.pickerOptions1 = {
        disabledDate(time) {
          return time.getTime() < Date.parse(that.drawer.info.planStartDate)
        }
      }
      this.permissionsChange(input)
    },
    // 订金日期
    permissionsDateStartDep(input) {
      // var that = this
      // this.pickerOptions1 = {
      //   disabledDate(time) {
      //     return time.getTime() < Date.parse(that.drawer.info.planStartDate)
      //   }
      // }
      // this.date_time = false
      // if (this.drawer.info.planStartDate && this.drawer.info.planEndDate) {
      //   var date = this.getDifferTime(
      //     that.drawer.info.planStartDate,
      //     that.drawer.info.planEndDate
      //   )
      //   if (date === this.drawer.info.planWorkTime) {
      //     this.date_time = true
      //   }
      // }
      this.permissionsChange(input)
    },
    // 图纸确认日期
    permissionsDateStartDraw(input) {
      this.permissionsChange(input)
    },
    // 预计完成日期
    permissionsDateStartPlanEnd(input) {
      this.permissionsChange(input)
    },
    // 基本信息编辑
    permissionsChange(input, type) {
      this.edit_input = input
      if (input !== 'describe') {
        this.permissionsFocus(input, type)
      }
    },
    // 获取焦点
    permissionsFocus(input, type) {
      // var that = this
      if (this.drawer.info.editFlag && this.drawer.info.delFlag !== '2') {
        this.$nextTick(() => {
          this.$refs[input].focus()
        })
        // 下拉菜单
        if (type === 'select') {
          this.$refs[input].toggleMenu()
        }
      }
      if (this.$refs.forms) {
        this.$refs.forms.closeEditForm()
      }
    },
    // 表单富文本编辑
    editFormChange(key, value) {
      if (this.$refs.forms) {
        this.$refs.forms.editFormTask()
      }
    },
    // 关闭编辑
    closePermission() {
      this.edit_input = ''
      if (this.$refs.forms) {
        this.$refs.forms.closeEditForm()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/index.scss';
.info_value ::v-deep .el-input__inner {
  height: 35px;
  line-height: 35px;
  border-color: #E9E9EA;
  font-size: $font_14;
  font-family: $font_family;
  font-weight: 400;
  padding: 0 10px;
  color: $color_2;
}
.info_valueEditFlag:hover{
  background: #f8f8f8 !important;
  border-radius: 4px !important;
}

.card_img {
  width: 100%;
  vertical-align: middle;
}
.info_card_imgs {
  width: 157px;
  height: 87px;
  border-radius: 10px;
  border: 1px solid #E2E2E2;
  overflow: hidden;
}
.info_card_img {
  width: 100%;
}
.info_tags {
  .del_icon {
    font-size: 15px;
    color: $color_9;
    position: absolute;
    top: -15px;
    right: -6px;
    display: none;
  }
}
.info_tags:hover .del_icon {
  display: block;
}
.info_conts {
  overflow: auto;
  ::v-deep .el-input__inner {
    height: 35px;
    line-height: 35px;
    border-color: #e9e9ea;
    font-size: $font_14;
    font-family: $font_family;
    font-weight: 400;
    padding: 0 10px;
    color: $color_2;
  }
  ::v-deep .el-date-editor .el-range-input {
    width: 135px;
    text-align: left;
  }
  ::v-deep .el-date-editor .el-range-separator {
    width: 45px;
    line-height: 35px;
    padding: 0;
    text-align: center;
  }
}
/* 标签页默认样式 */
::v-deep .el-tabs__nav-scroll {
  padding: 0;
}
::v-deep .el-tabs__content {
  padding: 0 !important;
}
::v-deep .el-input__inner {
  height: 35px;
  line-height: 35px;
  border-color: #E9E9EA;
  font-size: $font_14;
  font-family: $font_family;
  font-weight: 400;
  color: $color_2;
}
.info_titleimg ::v-deep .el-button {
  padding: 5px 15px;
  font-size: $font_12;
  color: $color_8;
}
::v-deep .el-radio__inner {
  border-radius: 2px !important;
  width: 15px !important;
  height: 15px !important;
}

::v-deep .el-radio__input.is-checked .el-radio__inner::after {
    content: "";
    width: 7px;
    height: 4px;
    border: 2px solid white;
    border-top: transparent;
    border-right: transparent;
    text-align: center;
    display: block;
    position: absolute;
    top: 3px;
    left: 2px;
    vertical-align: middle;
    transform: rotate(-45deg);
    border-radius: 2px;
    background: none;
}
::v-deep .el-radio__input.is-checked .el-radio__inner{
  background: $color_main !important;
    border-color: #ffffff !important;
}
::v-deep .el-radio__input.is-checked + .el-radio__label{
  color: #606266 !important;
}
.form_fieldName {
  width: 69px;
    color: $color_8;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.info_conts {
  overflow: auto;
  ::v-deep .el-input__inner {
    height: 35px;
    line-height: 35px;
    border-color: #e9e9ea;
    font-size: $font_14;
    font-family: $font_family;
    font-weight: 400;
    padding: 0 10px;
    color: $color_2;
  }
  ::v-deep .el-date-editor .el-range-input {
    width: 135px;
    text-align: left;
  }
  ::v-deep .el-date-editor .el-range-separator {
    width: 45px;
    line-height: 35px;
    padding: 0;
    text-align: center;
  }
}
</style>
